module.exports = __webpack_public_path__ + "static/media/madhvi-avatar.d0d6bbcd.jpg";